import { useDisclosure } from 'further-ui/hooks';
import DropdownMenu from 'components/DropdownMenu';
import DownloadStatementDialog from './DownloadStatementDialog';

type Props = {
  title: string;
  loading: boolean;
  hideDescription?: boolean;
  onDownloadCurrentValuation: () => void;
  onDownloadEarlierValuation: (date: Date) => void;
};

const DownloadStatementMenu: React.FC<Props> = ({
  title,
  loading,
  hideDescription,
  onDownloadCurrentValuation,
  onDownloadEarlierValuation,
}) => {
  const downloadStatementDisclosure = useDisclosure();

  const actions = [
    {
      label: 'Download current valuation',
      onClick: onDownloadCurrentValuation,
    },
    {
      label: 'Download earlier valuation',
      onClick: downloadStatementDisclosure.onOpen,
    },
  ];

  return (
    <DropdownMenu
      title={title}
      loading={loading}
      actions={actions}
      size="small"
      menuId="statement-menu"
      dialog={
        <DownloadStatementDialog
          title={title}
          hideDescription={hideDescription}
          open={downloadStatementDisclosure.isOpen}
          onClose={downloadStatementDisclosure.onClose}
          onConfirm={(date) => {
            onDownloadEarlierValuation(date);
            downloadStatementDisclosure.onClose();
          }}
        />
      }
    />
  );
};

export default DownloadStatementMenu;
